import { useTheme } from 'react-native-paper';

export function useThemedColor(light: string, dark: string) {
  return useTheme().dark ? dark : light;
}
